import { syntaxTree } from '@codemirror/language';
import { linter, type Diagnostic } from '@codemirror/lint';
import type { Tree } from '@lezer/common';
import type { EditorView } from '@codemirror/view';

/**
 * Pure tree-walk: collect a diagnostic for every error node in a Lezer tree.
 * Decoupled from EditorView so it's testable from a bare parse.
 */
export function diagnosticsFromTree(tree: Tree, src: string): Diagnostic[] {
  const diagnostics: Diagnostic[] = [];
  const cursor = tree.cursor();
  do {
    if (cursor.type.isError) {
      const from = Math.min(cursor.from, src.length);
      const to = Math.min(Math.max(cursor.to, from + 1), src.length);
      if (to > from) {
        diagnostics.push({ from, to, severity: 'error', message: 'Syntax error' });
      }
    }
  } while (cursor.next());
  return diagnostics;
}

/** CM linter source: walk the parsed tree of the current document. */
export function htmlDiagnostics(view: EditorView): Diagnostic[] {
  const src = view.state.doc.toString();
  return diagnosticsFromTree(syntaxTree(view.state), src);
}

export const htmlLinter = linter(htmlDiagnostics);
